import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { getFriendsWithBenefitsRates } from "@/components/FriendsWithBenefits/FriendsWithBenefitsRates.tsx";
import { RateCard } from "@/components/Layout/Rates/RateCard/RateCard";
import { stripCurrencyPrefix } from "@/utils/tariffUtils";

interface Props {
  dataTestid?: string;
  tribeDiscount: number;
  /** Optional header action (e.g. order CTA on the group overview). */
  action?: ReactNode;
}

/** Display-only rate tiles matching the rate-selection product cards. */
export const WelcomeRateCards: FC<Props> = ({
  dataTestid,
  tribeDiscount,
  action,
}) => {
  const { t } = useTranslation();
  const hasDiscount = tribeDiscount > 0;
  const rates = getFriendsWithBenefitsRates({ t, tribeDiscount });

  return (
    <div data-testid={dataTestid} className="flex w-full flex-col gap-6">
      <div className="flex w-full items-start gap-3">
        <p className="min-w-0 flex-1 text-body-base font-semibold leading-md text-foreground-primary">
          {t("friendsWithBenefits.welcome.rates")}
        </p>
        {action}
      </div>

      <div className="grid gap-6 tablet:grid-cols-2 desktop:grid-cols-3">
        {rates.map((rate) => (
          <RateCard
            key={rate.serviceId}
            selectionMode="display"
            product={{
              id: rate.serviceId,
              baseDisplayValue: rate.name,
              chargeFlat: hasDiscount ? rate.discountPrice : rate.price,
              minContractDur: 30,
              isVoiceProduct: true,
            }}
            originalPrice={
              hasDiscount ? stripCurrencyPrefix(rate.price) : undefined
            }
          />
        ))}
      </div>
    </div>
  );
};
